import moment from "moment-timezone";

export default function getEventStatus(timestamp) {
  const saleStartDate = new Date(timestamp);

  const formattedDate = moment.utc(saleStartDate).format("D MMM YYYY, h:mma");
  return formattedDate;
}
